import styled from "styled-components";
import { Radio } from "antd";

type Props = {
    border: string;
}
export const Wrapper = styled(Radio)`
  padding: 12px 14px;
  height: 48px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-family: "Inter";
  border: 1px solid ${(props: Props) => props.border ? props.border : 'transparent'};

  &:hover {
    border: 1px solid #a3a3a3;
  }

  & > span:not([class~="ant-radio"]) {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #000000;
    padding-left: 10px;
  }
  & > span[class~="ant-radio"] > span[class~="ant-radio-inner"] {
    box-sizing: border-box;
    width: 20px;
    height: 20px;
  }
  & > span[class~="ant-radio"] {
    top: 0;
  }
  & > span[class~="ant-radio-checked"] > span[class~="ant-radio-inner"] {
    background-color: var(--primary-brand);

    background-color: ${props => props.checked ? "var(--primary-brand)" : "transparent"};
    border-color: ${props => props.checked ? "var(--primary-brand)" : "#d9d9d9"};
  }
  & > span[class~="ant-radio-checked"] > span[class~="ant-radio-inner"]:after {
    background-color: #ffffff;
    width: 10px;
    height: 10px;
    margin-top: -5px;
    margin-left: -5px;
    opacity: ${props => props.checked ? 1 : 0};
  }
`;